import { DeviceTypes, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { generateDeviceDomainTreeDef, generateEntityDomainTreeDef } from './generateDomainTreeDef';
export const generateDomainTreeMap = (domain, objectTypeIds, deviceTypes, sortOrder = 100) => {
    const common = {
        domainKey: domain,
        sortOrder,
    };
    const userDomain = {
        ...common,
        targetSectionPath: ['User'],
        treeDefMap: Object.fromEntries(objectTypeIds.map((objectTypeId) => [`${domain}_${objectTypeId}`, generateEntityDomainTreeDef(domain, objectTypeId, 'user', undefined, 'User')])),
    };
    const setupEntitiesDomain = {
        ...common,
        targetSectionPath: ['SetUp'],
        treeDefMap: Object.fromEntries(objectTypeIds.map((objectTypeId) => [`${domain}_${objectTypeId}`, generateEntityDomainTreeDef(domain, objectTypeId, 'user', undefined, 'SetUp')])),
    };
    const setupDevicesDomain = {
        ...common,
        targetSectionPath: ['SetUp', 'Devices'],
        treeDefMap: domain !== UNCLASSIFIED_DOMAIN
            ? Object.fromEntries(deviceTypes.map((deviceType) => [DeviceTypes[deviceType], generateDeviceDomainTreeDef(domain, deviceType, 'user')]))
            : { [UNCLASSIFIED_DOMAIN]: generateEntityDomainTreeDef(UNCLASSIFIED_DOMAIN, 'Device', 'user', 'Devices') },
    };
    const adminEntitiesDomain = {
        ...common,
        targetSectionPath: ['Admin'],
        treeDefMap: Object.fromEntries(objectTypeIds.map((objectTypeId) => [
            `${domain}_${objectTypeId}`,
            generateEntityDomainTreeDef(domain, objectTypeId, 'admin', undefined, `Admin_${domain}_${objectTypeId}`),
        ])),
    };
    const adminDevicesDomain = {
        ...common,
        targetSectionPath: ['Admin', 'Devices'],
        treeDefMap: domain !== UNCLASSIFIED_DOMAIN
            ? Object.fromEntries(deviceTypes.map((deviceType) => [DeviceTypes[deviceType], generateDeviceDomainTreeDef(domain, deviceType, 'admin')]))
            : { [UNCLASSIFIED_DOMAIN]: generateEntityDomainTreeDef(UNCLASSIFIED_DOMAIN, 'Device', 'admin', 'Devices') },
    };
    return [userDomain, setupEntitiesDomain, setupDevicesDomain, adminEntitiesDomain, adminDevicesDomain];
};
